import React, { cloneElement, FC, isValidElement, PropsWithChildren, useEffect } from 'react';
import { RouteChildrenProps } from 'react-router-dom';
import { WixConnection } from './components/wix-connection';
import { SiteSessionWrapper } from './modules/sites/site-session-wrapper';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeicons/primeicons.css';
import { Bootstrap } from 'src/redesign/app';
import { MainLayout } from 'src/redesign/layouts';
import { usePostHog } from 'posthog-js/react';
import { isEmpty } from 'lodash';
import { Header } from 'src/redesign/features/Header';
import { Tabs } from 'src/redesign/features/Tabs';
import { AuthRouter } from 'src/features/AuthRouter';
import { PublicRouter } from 'src/features/PublicRouter';
import styles from './App.module.scss';
import { useAppSelector } from 'src/hooks';
import { accountSelector } from 'src/redesign/features/Account/store/selectors';
import { Modals } from 'src/redesign/features/Modals';
import { globalReloadingSelectors } from 'src/redesign/shared/store/selectors';
import { Loader } from 'wix-style-react';

export const App = () => {
  const account = useAppSelector(accountSelector);
  const posthog = usePostHog();
  const queryParams = new URLSearchParams(window.location.search);
  const isCreateEvent = queryParams.get('is_create_event');
  const globalReloading = useAppSelector(globalReloadingSelectors);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       if (!isEmpty(account) && !isCreateEvent) {
  //         if (!account.last_site_accessed && !account.last_widget_accessed) {
  //           const form = document.createElement('form');
  //           form.method = 'POST';
  //           form.action = `${process.env.API_SERVICE_URL}/api/v1/accounts/select-site`;
  //           document.body.appendChild(form);
  //           form.submit();
  //           return;
  //         }
  //
  //         // Assuming isCreateEvent is not needed here since we're not using Redux state
  //         window.Intercom('boot', {
  //           app_id: 'm51ut11q',
  //           email: account.email,
  //           site_id: account?.last_site_accessed?.name,
  //           widget_id: account?.last_widget_accessed?.name,
  //         });
  //         posthog?.identify(account.email, {
  //           email: account.email,
  //         });
  //       }
  //       const siteId = account.last_site_accessed.name;
  //       const widgetId = account.last_widget_accessed.name;
  //       dispatch(fetchSite(siteId));
  //       dispatch(fetchWidgetApi({ siteId, widgetId }));
  //       dispatch(fetchSettingsApi());
  //       dispatch(getFonts());
  //       setIsLoading(false);
  //
  //       if (account.must_verify_email && account.email_verified_at === null) {
  //         history.push('/email-verification');
  //       }
  //     } catch (e) {
  //       if (
  //         window.brand !== 'wix' &&
  //         !history.location.pathname.includes('auth/') &&
  //         !history.location.pathname.includes('/new-event') &&
  //         !history.location.pathname.includes('/wix/pricing')
  //       ) {
  //         history.push('/auth/login');
  //       }
  //       setIsLoading(false);
  //     }
  //   };
  //   void fetchData();
  // }, [dispatch]);
  // const queryParams = new URLSearchParams(window.location.search);
  // const isCreateEvent = queryParams.get('is_create_event');

  // useEffect(() => {
  //   if (account && account.must_verify_email && account.email_verified_at === null) {
  //     history.push('/email-verification');
  //   }
  //
  //   if (
  //     window.brand !== 'wix' &&
  //     !location.pathname.includes('auth/') &&
  //     !location.pathname.includes('/new-event') &&
  //     !location.pathname.includes('/wix/pricing') &&
  //     fetchAccountError
  //   ) {
  //     history.push('/auth/login');
  //   }
  //
  //   if (window.brand !== 'wix') {
  //     dispatch(getFonts());
  //   }
  // }, [dispatch, account, fetchAccountError, location.pathname, history]);
  //
  // useEffect(() => {
  //   if (history.location.pathname === '/' && window.brand !== 'wix') {
  //     const form = document.createElement('form');
  //     form.method = 'POST';
  //
  //     console.log('form');
  //     form.action = `${process.env.API_SERVICE_URL}/api/v1/accounts/select-site`;
  //     document.body.appendChild(form);
  //
  //     form.submit();
  //     return;
  //   }
  //   if (
  //     window.brand === 'wix' &&
  //     !siteData.compId &&
  //     !history.location.pathname.includes('/wix/pricing')
  //   ) {
  //     history.replace('/wix-widgets');
  //   }
  //

  useEffect(() => {
    if (!isEmpty(account) && !isCreateEvent) {
      window.Intercom('boot', {
        app_id: 'm51ut11q',
        email: account.email,
        shop_id: account.shop_id,
        account_id: account.id,
      });
      posthog?.identify(account.email, {
        email: account.email,
      });
    }
  }, [account, isCreateEvent, posthog]);

  if (
    process.env.NODE_ENV === 'production' &&
    window.brand === 'wix' &&
    !account?.has_app_updated
  ) {
    return <WixConnection />;
  }

  return (
    <Bootstrap>
      {account ? (
        <>
          <Header />
          <Tabs />
          <MainLayout>{globalReloading ? <Loader size="large" /> : <AuthRouter />}</MainLayout>
          <Modals />
        </>
      ) : (
        <div className={styles.publicPageWrapper}>
          <PublicRouter />
        </div>
      )}
    </Bootstrap>
  );

  // return (
  //   <div className="App">
  //     {window.brand === 'wix' && account.newsletter_opt_in === null && (
  //       <NewsletterOptIn account={account} />
  //     )}
  //     {/* {account.display_review_offer === null && <LeaveReview account={account} />} */}

  //   </div>
  // );
};

export const SiteWrapper: FC<PropsWithChildren<RouteChildrenProps & { noAuth?: boolean }>> = (
  props
) => {
  const { children, match, noAuth } = props;
  const params = match.params as { site_id?: string };
  return (
    <SiteSessionWrapper siteId={params?.site_id} noAuth={noAuth}>
      {isValidElement(children) && cloneElement(children, { ...props })}
    </SiteSessionWrapper>
  );
};
